// shared-state.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedStateService {
   private templatesUpdatedSubject = new BehaviorSubject<boolean>(false);
  
  templatesUpdated$: Observable<boolean> = this.templatesUpdatedSubject.asObservable();

  // Estados para cada entidad
  private groupsUpdatedSubject = new BehaviorSubject<boolean>(false);
  private membersUpdatedSubject = new BehaviorSubject<boolean>(false);
  //private templatesUpdatedSubject = new BehaviorSubject<boolean>(false);

  // Observables públicos
  groupsUpdated$: Observable<boolean> = this.groupsUpdatedSubject.asObservable();
  membersUpdated$: Observable<boolean> = this.membersUpdatedSubject.asObservable();
  //templatesUpdated$: Observable<boolean> = this.templatesUpdatedSubject.asObservable();


  notifyGroupsUpdated(): void {
    this.groupsUpdatedSubject.next(true);
  }

  notifyMembersUpdated(): void {
    this.membersUpdatedSubject.next(true);
  }

  notifyTemplatesUpdated(): void {
    this.templatesUpdatedSubject.next(true);
  }

  resetTemplatesState(): void {
    this.templatesUpdatedSubject.next(false);
  }
}